import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <link rel="icon" type="image/png" href="%PUBLIC_URL%/favicon.png" />

    <App />
  </React.StrictMode>
);
